const GET_ADDRESS_DETAILS = 'GET_ADDRESS_DETAILS';
const SET_ADDRESS_DETAILS = 'SET_ADDRESS_DETAILS';

export {
    GET_ADDRESS_DETAILS,
    SET_ADDRESS_DETAILS
};